import React from 'react';

export const initialsOf = (name = '') =>
  String(name || '').trim().split(/\s+/).map((w) => w[0] || '').join('').slice(0, 2).toUpperCase();

/** Circular initials avatar. `size` in px. Decorative unless `label` is given. */
const Avatar = ({ name, initials, size = 30, fontSize, label }) => {
  const text = initials || initialsOf(name);
  return (
    <span
      className="cw-avatar"
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      style={{ width: size, height: size, fontSize: fontSize || `max(var(--cs-text-xs, 0.7rem), ${Math.max(0.7, size / 42)}rem)` }}
    >
      {text}
    </span>
  );
};

/** Assigned-person cell: muted "Unassigned" or avatar + name. */
export const PersonCell = ({ name }) => {
  if (!name) return <span className="cw-meta">Unassigned</span>;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <Avatar name={name} size={24} fontSize="var(--cs-text-xs, 0.7rem)" />
      <span style={{ fontSize: 'var(--cs-text-sm, 0.8125rem)' }}>{name}</span>
    </span>
  );
};

export default Avatar;
